import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import * as Reducers from 'src/app/store/reducers';
import * as UserActions from 'src/app/store/user/actions';
import * as SettingsActions from 'src/app/store/settings/actions';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-system-login',
	templateUrl: './login.component.html',
	styleUrls: ['../style.component.scss']
})
export class LoginComponent implements OnDestroy {
	form: FormGroup;
	logo: string;
	authProvider = 'jwt';
	loading = false;

	private subscription = new Subscription();

	constructor(private fb: FormBuilder, private store: Store<any>) {
		this.form = fb.group({
			email: ['', [Validators.required, Validators.minLength(3)]],
			password: ['', [Validators.required]]
		});
		this.subscription.add(this.store.pipe(select(Reducers.getSettings)).subscribe(state => {
			this.logo = state.logo;
			this.authProvider = state.authProvider;
		}));
		this.subscription.add(this.store.pipe(select(Reducers.getUser)).subscribe(state => {
			this.loading = state.loading;
		}));
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	get email() {
		return this.form.controls.email;
	}
	get password() {
		return this.form.controls.password;
	}

	submitForm(): void {
		this.email.markAsDirty();
		this.email.updateValueAndValidity();
		this.password.markAsDirty();
		this.password.updateValueAndValidity();
		if (this.email.invalid || this.password.invalid) {
			return;
		}
		const payload = {
			email: this.email.value,
			password: this.password.value
		};
		this.store.dispatch(new UserActions.Login(payload));
	}

	setProvider(authProvider): void {
		this.store.dispatch(
			new SettingsActions.SetStateAction({
				authProvider
			})
		);
	}
}
